import { nextTick } from 'vue'

const autoFocusFirstInput = async (inputEl: HTMLInputElement | null) => {
  await nextTick()
  if (!inputEl) {
    return
  }
  setTimeout(() => {
    inputEl.focus()
  }, 200)
}

export { autoFocusFirstInput }
